module.exports = __webpack_public_path__ + "img/frameCardImg.2971556d.png";